// extracted by mini-css-extract-plugin
module.exports = {"apptStatusViewContainer":"MainView_apptStatusViewContainer__1H4Gc"};